import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_REJECT_CLAIM_ITEM } from "../../action-types/actions";

export const rejectClaimItem = createAsyncThunk(
  ACTIONS_REJECT_CLAIM_ITEM.rejectClaimItem,
  async ({ claimId, item_id, reason }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.claimsRejectItem.replace(
          "{claimId}",
          claimId,
        )}`,
        {
          item_id,
          reason,
        },
      );

      if (response?.data?.status === true || response?.status === 200) {
        toast.success("Claim item rejected successfully");
        return response.data;
      } else {
        toast.error(response?.data?.message || "Failed to reject claim item");
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("Reject claim item error:", error);
      const errMsg =
        error?.response?.data?.message ||
        "Something went wrong while rejecting claim item";
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
